// entityCards.js — the Entity page cards a tenant ticks per Relationship
// Type on the Entity Cards grid (issue #249, vis_relationship_lifecycle.md
// §4). Mirrors backend/config/entityCards.js. Identity, Addresses, Phones,
// Emails, Activities and Opening Hours sit outside the grid and always
// show.
//
// withRecords cards list records, and also show whenever they hold at
// least one, so history never goes out of view when a relationship
// changes. The rest follow the grid strictly.
export const ENTITY_CARDS = [
  { key: 'relationship', label: 'Relationship' },
  { key: 'classification', label: 'Classification' },
  { key: 'operators', label: 'Operators' },
  { key: 'legal', label: 'Legal' },
  { key: 'social_media', label: 'Social Media' },
  { key: 'currency', label: 'Currency' },
  { key: 'customer_terms', label: 'Customer Terms' },
  { key: 'price_groups', label: 'Price Groups', withRecords: true },
  { key: 'preferences', label: 'Preferences' },
  { key: 'people', label: 'People', withRecords: true },
  { key: 'companies', label: 'Companies', withRecords: true },
  { key: 'trade_shows', label: 'Trade Shows', withRecords: true },
  { key: 'quotes', label: 'Quotes', withRecords: true },
  { key: 'sales_orders', label: 'Sales Orders', withRecords: true },
];

// Cards ticked for any Relationship Type the Entity holds — the Principal
// flag plays no part.
export function tickedCardKeys(entity) {
  return new Set((entity?.relationships || []).flatMap((r) => r.relationship_type?.card_keys || []));
}
